export default __webpack_public_path__ + "static/media/git.c20f38ca.svg";